import * as yup from "yup";

export default (intl) =>
  yup.object({
    firstName: yup.string().required(
      intl.formatMessage({
        id: "First name is required.",
        defaultMessage: "First name is required.",
      })
    ),
    lastName: yup.string().required(
      intl.formatMessage({
        id: "Last name is required.",
        defaultMessage: "Last name is required.",
      })
    ),
    companyName: yup.string().required(
      intl.formatMessage({
        id: "Company name is required.",
        defaultMessage: "Company name is required.",
      })
    ),
    country: yup
      .object()
      .nullable()
      .required(
        intl.formatMessage({
          id: "Advertise Jobs in is required.",
          defaultMessage: "Advertise Jobs in is required.",
        })
      ),
    email: yup
      .string()
      .email(
        intl.formatMessage({
          id: "Email must be a valid email.",
          defaultMessage: "Email must be a valid email.",
        })
      )
      .required(
        intl.formatMessage({
          id: "Email is required.",
          defaultMessage: "Email is required.",
        })
      ),
    password: yup
      .string()
      .min(
        8,
        intl.formatMessage({
          id: "Password must be at least 8 characters.",
          defaultMessage: "Password must be at least 8 characters.",
        })
      )
      .required(
        intl.formatMessage({
          id: "Password is required.",
          defaultMessage: "Password is required.",
        })
      ),
  });
